import { User } from '../../user/models/user.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable()
export class AdminService {
  constructor(private readonly http: HttpClient) {}

  getAllAdmins(): Observable<{ count: number, data: User[] }> {
    return this.http.get<{ count: number, data: User[] }>(`${environment.apiUrl}/users?role=admin`);
  }

  createAdmin(payload: User): Observable<User> {
    return this.http.post<User>(`${environment.apiUrl}/users`, {
      ...payload,
    });
  }

  deleteAdmins(payload: { ids: number[] }): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        ids: payload.ids
      },
    };

    return this.http.delete<any>(`${environment.apiUrl}/users`, options);
  }
}
